import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

const addUpdateMaintenancePlanApi = (data, callback, errorCallBack, params) => {

    return async (dispatch) => {

        formDataCommonFunction(data, apiConstants.HOME_MAINTENANCE.ADD_UPDATE_MAINTENANCE_PLAN)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}

export default addUpdateMaintenancePlanApi;
